import emptyTransactions from '@/assets/lotties/empty_coupon.json';
import loadingError from '@/assets/lotties/payment_failure.json';

export const EVENTS = {
  COUPONS: {
    LIST_ALL: {
      REFRESH: 'COUPONS.LIST_ALL.REFRESH',
      REFRESHING: 'COUPONS.LIST_ALL.REFRESHING',
      REFRESHED: 'COUPONS.LIST_ALL.REFRESHED',
      REFRESH_ERROR: 'COUPONS.LIST_ALL.REFRESH_ERROR'
    },
    DETAIL: {
      SHOW: 'COUPONS.DETAIL.SHOW'
    }
  }
};

export const ENDPOINTS = {
  COUPONS: {
    GET_LIST: '/store/app/data?service=1bpay&userId=1bpay-coupons&group=lacasae'
  }
};

export const COUPONS = {
  LOTTIES: {
    EMPTY: emptyTransactions,
    LOADING_ERROR: loadingError
  }
};
